import React from 'react';
// This component is used in components/pages/overview/widgets/widget.jsx
const LocationStats = (props) => {
    return (
        <div className="widget-card__stats-block ">
            <div className="stats-block__total-rooms">
                <div className="total-rooms__title"><span>Total Rooms</span></div>
                <div className="total-rooms__number font--proLight"><span>{props.stats.allRooms}</span></div>
                <div className="total-rooms__rooms-inuse"><span id="rooms-inuse">{props.stats.roomsInUse}</span><span> in use   </span></div>
            </div>

            <div className="stats-block__total-desks">
                <div className="total-desks__title"><span>Total Desks</span></div>
                <div className="total-desks__number font--proLight"><span>{props.stats.allSensors}</span></div>
                <div className="total-desks__desks-inuse"><span id="desks-inuse">{props.stats.desksInUse}</span><span> in use   </span></div>
            </div>
        </div>
    );
}
export default LocationStats


// WEBPACK FOOTER //
// ./src/components/common/widgets/locationstats.jsx